export default {
	parameters: {
		client: 'gme-lifetimefitnessinc',
		v: '3.21',
		libraries: 'places,geometry',
		callback: 'mapLoadingCallback',
		channel: 'aem-web'
	},
	url: 'https://maps.googleapis.com/maps/api/js',
	map: {
		defaultConfig: {
			center: {
				lat: 44.8599412,
				lng: -93.5953929
			},
			panControl: false,
			scrollwheel: false,
			minZoom: 4,
			zoom: 10,
			styles: [
				{
					'featureType': 'landscape.man_made',
					'elementType': 'geometry'
				}, {
					'featureType': 'landscape.natural',
					'elementType': 'geometry',
					'stylers': [{'color': '#f0f0f0'}, {'visibility': 'on'}]
				}, {
					'featureType': 'poi',
					'elementType': 'labels',
					'stylers': [{'visibility': 'off'}]
				}, {
					'featureType': 'poi.business',
					'elementType': 'all',
					'stylers': [{'visibility': 'off'}]
				}, {
					'featureType': 'poi.medical',
					'elementType': 'geometry',
					'stylers': [{'color': '#fbd3da'}]
				}, {
					'featureType': 'poi.park',
					'elementType': 'geometry',
					'stylers': [{'color': '#e5e5e5'}]
				}, {
					'featureType': 'road',
					'elementType': 'geometry.stroke',
					'stylers': [{'visibility': 'off'}]
				}, {
					'featureType': 'road',
					'elementType': 'labels',
					'stylers': [{'visibility': 'simplified'}]
				}, {
					'featureType': 'road.highway',
					'elementType': 'geometry.fill',
					'stylers': [{'color': '#fad740'}]
				}, {
					'featureType': 'road.highway',
					'elementType': 'geometry.stroke',
					'stylers': [{'color': '#f9c830'}, {'visibility': 'on'}]
				}, {
					'featureType': 'road.arterial',
					'elementType': 'geometry.fill',
					'stylers': [{'color': '#ffffff'}]
				}, {
					'featureType': 'road.local',
					'elementType': 'geometry.fill',
					'stylers': [{'color': 'black'}]
				}, {
					'featureType': 'transit.station.airport',
					'elementType': 'geometry.fill',
					'stylers': [{'color': '#c7bace'}]
				}, {
					'featureType': 'water',
					'elementType': 'geometry',
					'stylers': [{'color': '#b3eaee'}]
				}
			]
		}
	},
	main: '#locate-a-club',
	mapControls: '.gm-control-active',
	mapFullscreenBtn: '.gm-fullscreen-control',
	resultsScroll: '.results-scroll, .pcl-results-list',
	resultsList: '.results-list li',
	resultsListSelectedItem: '.results-list li.selected',
	resultsCount: '.results-count, .pcl-result-count'
};
